// extracted by mini-css-extract-plugin
export default {"business_card":"BusinessNoInfoCap_business_card__XpCTE","icon_wrapper":"BusinessNoInfoCap_icon_wrapper__k+NAC","cap_text":"BusinessNoInfoCap_cap_text__Wjb04"};